// import React from 'react'
// import { BitcoinProvider, SolanaProvider, EthereumProvider } from 'views/layouts'

export const WALLET_PROVIDERS = {
  bitcoin: 'bitcoin',
  solana: 'solana',
  ethereum: 'ethereum',
}
